import {
    isCancellingTicket,
    isDistributingTicket,
    isTicketDistributed,
    isTicketDistributedOrBeingDistributed,
} from '@/app/modules/seating/guestOperations/Picker/domain/tickets/tickets';
import { ETicketingType, type IETicketingType } from '@/app/shared/enums/ETicketingType.ts';
import { hasSeatPhysicalDistribution } from '@/app/modules/seating/guestOperations/Picker/domain/tickets/ticketsDistribution.ts';

export const canSelectTicket = (ticket: any) =>
    !isTicketDistributed(ticket) && !isDistributingTicket(ticket);

export const canCancelTicket = (
    ticket: any,
    seat: any,
    eTicketingType: IETicketingType,
    { forbidIfCancelling = true }: { forbidIfCancelling: boolean }
) => {
    if (!ticket || eTicketingType === ETicketingType.DISABLED) {
        return false;
    }

    if (ticket.guest.distribute_with_sales_portal === true) {
        return false;
    }

    if (eTicketingType === ETicketingType.SECUTIX && seat && hasSeatPhysicalDistribution(seat)) {
        return false;
    }

    if (forbidIfCancelling && isCancellingTicket(ticket)) {
        return false;
    }

    return isTicketDistributedOrBeingDistributed(ticket);
};
